// 组件对象，大写
import iconDiv from './iconDiv.vue'
export default iconDiv
